"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverlapWrapper = exports.TextWrapper = exports.IconWrapper = exports.ContentWrapper = exports.ProcessingWrapper = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
exports.ProcessingWrapper = components_core_1.styled.div `
         width: 100vw;
         height: 100vh;
         right: 0px;
         background: ${props => props.theme.colors.overlay.default};
         top: 0;
         display: flex;
         align-items: center;
         justify-content: center;
       `;
exports.ContentWrapper = components_core_1.styled.div `
         height: 100vh;
         width: 100vw;
         background: white;
         display: flex;
         flex-flow: column;
         align-items: center;
         justify-content: center;
         @media (min-width: ${components_core_1.Breakpoints.b960}px) {
           height: 232px;
           width: 300px;
         }
       `;
exports.IconWrapper = components_core_1.styled.div `
  width: 80px;
  height: 80px;
`;
exports.TextWrapper = components_core_1.styled.div `
  width: 100%;
  margin-top: 21px;
`;
exports.OverlapWrapper = components_core_1.styled.div `
         z-index: 1000;
         position: fixed;
         width: 100%;
         height: 100%;
       `;
